export function getCellMergeInfo(table, col, row) {
    var _a;
    if (table.internalProps.customMergeCell) {
        const customMerge = table.getCustomMerge(col, row);
        if (customMerge) return customMerge.range;
    }
    if (!table.internalProps.enableTreeNodeMerge && !table.isHeader(col, row) && !(null === (_a = table.getBodyColumnDefine(col, row)) || void 0 === _a ? void 0 : _a.mergeCell)) return !1;
    const range = table.getCellRange(col, row);
    return !(range.start.col === range.end.col && range.start.row === range.end.row) && range;
}
//# sourceMappingURL=get-cell-merge.js.map
